import React from "react";
import styled from "styled-components";
import SearchIcon from "src/assets/images/Icon_Search.svg";

const Container = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  height: 100%;
`
const InputContainer = styled.input`
    border-radius : 5px;
    border : 1px solid #ccc;
    width: 100%;
    height: 100%;
    display: block;
    flex-grow: 1;
    padding: 0px 20px;
    &:focus{
    outline: none;
    border: 1px solid #39B95B !important;
    }
`
const ImgContainer = styled.div`
  position: absolute;
  right: 10px; /* 오른쪽 아이콘 */
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  cursor: pointer;
`

interface Props {
  type? :string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  pattern? : string;
  title? : string;
  value? : string;
  onClick?: () => void;
  icon? : React.ReactNode;
  inputStyle?: React.CSSProperties;
}

const InputBoxSearch = ({ placeholder, type, onChange, pattern, title, value, onClick, icon, inputStyle }: Props) => {

  return (
    <Container>
      <InputContainer
        type={type}
        placeholder={placeholder}
        onChange={onChange}
        pattern={pattern}
        title={title}
        value={value}
        onKeyDown={(e) => {
          if (e.key === 'Enter') onClick?.()
        }}
        style={inputStyle}
      />
      <ImgContainer onClick={onClick}>
        {icon ? 
        icon:
        <img src={SearchIcon} alt="" />
        }
        
      </ImgContainer>
    </Container>
  );
};

export default InputBoxSearch;
